export const MIN_GEOFENCE_RADIUS = 1;
export const MAX_GEOFENCE_RADIUS = 999;
export const MAX_GEOFENCE_RADIUS_LENGTH = 3;
export const DEFAULT_GEOFENCE_RADIUS_MILES = 30;
